import { FORMAT_DEFINITIONS } from './constants';
import { calculateFormatOutput } from './scenarioCalculations';
import { formatCurrency } from './formatters';

const FAMILY_LABELS = {
    rtd: 'Ready to Drink',
    concentrate: 'Concentrate',
};

const WizardStep4Review = ({
    activeProduct,
    selectedFamily,
    selectedFormatId,
    quantityValue,
    viewMode,
    availableKegs,
    canCreatePlan,
    blockedReason,
    onBack,
    onCreatePlan,
}) => {
    const format = FORMAT_DEFINITIONS[selectedFormatId];

    let projectedOutput = '—';
    let inventoryUsed = '—';
    let estRevenue = '—';
    let quantityDisplay = '—';

    if (format && quantityValue > 0) {
        if (viewMode === 'capacity') {
            const result = calculateFormatOutput(quantityValue, selectedFormatId);
            projectedOutput = `${Math.floor(result.units).toLocaleString()} ${format.unit}`;
            inventoryUsed = `${quantityValue.toFixed(2)} kegs`;
            estRevenue = `${formatCurrency(result.wsRevenue)} / ${formatCurrency(result.retailRevenue)}`;
            quantityDisplay = `${quantityValue.toLocaleString(undefined, { maximumFractionDigits: 2 })} kegs`;
        } else {
            const kegsNeeded = quantityValue / format.per_concentrate_keg;
            projectedOutput = `${Math.floor(quantityValue).toLocaleString()} ${format.unit}`;
            inventoryUsed = `${kegsNeeded.toFixed(2)} kegs`;
            estRevenue = `${formatCurrency(quantityValue * format.pricing.ws)} / ${formatCurrency(quantityValue * format.pricing.retail)}`;
            quantityDisplay = `${quantityValue.toLocaleString(undefined, { maximumFractionDigits: 2 })} ${format.unit}`;
        }
    }

    const reviewRows = [
        { label: 'Product', value: activeProduct?.product_name || '—' },
        { label: 'Family', value: FAMILY_LABELS[selectedFamily] || '—' },
        { label: 'Format', value: format?.name || '—' },
        { label: 'Quantity', value: quantityDisplay },
        { label: 'Projected Output', value: projectedOutput },
        { label: 'Inventory Used', value: inventoryUsed },
        { label: 'Estimated Revenue (WS / Retail)', value: estRevenue },
    ];

    return (
        <div className="gsp-wizard-step gsp-step4 gsp-animate-in">
            <div className="gsp-step-section-header">
                <span className="gsp-step-num-badge">4</span>
                <div>
                    <h2 className="gsp-step-title">Review & Create Production Plan</h2>
                    <p className="gsp-step-subtitle">
                        Review your scenario before creating the production plan.
                    </p>
                </div>
            </div>

            <div className="gsp-review-card">
                <div className="gsp-review-table">
                    {reviewRows.map(({ label, value }) => (
                        <div key={label} className="gsp-review-row">
                            <span className="gsp-review-label">{label}</span>
                            <strong className="gsp-review-value">{value}</strong>
                        </div>
                    ))}
                </div>

                <div className="gsp-review-actions">
                    <button className="gsp-back-btn" onClick={onBack}>
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="16" height="16">
                            <line x1="19" y1="12" x2="5" y2="12" />
                            <polyline points="12 19 5 12 12 5" />
                        </svg>
                        Back
                    </button>
                    <div className="gsp-final-create-group">
                        <button
                            className="gsp-final-create-btn"
                            disabled={!canCreatePlan}
                            onClick={onCreatePlan}
                            title={canCreatePlan ? 'Create production plan' : blockedReason}
                        >
                            Create Production Plan
                        </button>
                        {!canCreatePlan && blockedReason && (
                            <p className="gsp-final-create-hint">{blockedReason}</p>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WizardStep4Review;
